import React from 'react';
import { LicensePlan } from '@/types/license';
import { usePricing } from '../../contexts/PricingContext';
import { getPriceForPeriod } from '../../utils/pricingUtils';

interface MatrixHeaderProps {
  plans: LicensePlan[];
}

export const MatrixHeader: React.FC<MatrixHeaderProps> = ({ plans }) => {
  const { period } = usePricing();

  return (
    <tr className="bg-gray-50">
      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-1/4">
        Features
      </th>
      {plans.map((plan) => {
        const price = getPriceForPeriod(plan, period);
        return (
          <th
            key={plan.id}
            className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
          >
            <div className="flex flex-col items-center gap-1">
              <span className="font-bold">{plan.name}</span>
              {price && (
                <span className="text-sm font-normal text-gray-600">{price}</span>
              )}
            </div>
          </th>
        );
      })}
    </tr>
  );
};